import {KTIcon} from '../../../_metronic/helpers'
import {usePaymentProvider} from './PaymentProvider'
import {useFormik} from 'formik'
import {initPaymentFilterValues, initPaymentMediaOptions, initPaymentStatus} from './core/_model'
import ReactSelectBox from '../../utils/components/ReactSelectBox'
import {useRittApp} from '../../utils/contextProvider/RittAppProvider'
import PrimaryFlatPickr from '../../utils/components/PrimaryFlatPickrDate'

const PaymentListFilter = () => {
  const {isLoading, itemsPerPage, setItemsPerPage, setCurrentPage, onRequestFilter} =
    usePaymentProvider()
  const {userInfo} = useRittApp()

  const formik = useFormik({
    initialValues: initPaymentFilterValues,
    onSubmit: async (values) => {
      try {
        console.log(values)
        const {username, ...sendvalues} = values

        const filteredValues = Object.fromEntries(
          Object.entries(sendvalues).filter(([_, v]) => v !== '' && v !== null && v !== undefined)
        )

        onRequestFilter(filteredValues)
      } catch (error) {
        console.log(error)
      }
    },
  })

  const onSelectUser = (id: number) => formik.setFieldValue('user', id)

  const resetFilter = () => {
    formik.resetForm()
    onRequestFilter(undefined)
    setCurrentPage(1)
  }

  return (
    <>
      {/* begin::Filter Button */}
      <button
        disabled={isLoading}
        type='button'
        className='btn btn-light-primary me-3 border border-1 border-gray-500'
        id='dropdownMenuButton'
        data-bs-toggle='dropdown'
        aria-expanded='false'
        data-bs-auto-close='outside'
      >
        <KTIcon iconName='filter' className='fs-2' />
        Filter
      </button>
      {/* end::Filter Button */}
      {/* begin::SubMenu */}
      <div
        className='dropdown-menu menu menu-sub menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-300px w-md-325px py-4 h-500px scroll-y'
        aria-labelledby='dropdownMenuButton'
      >
        {/* begin::Header */}
        <div className='px-7 py-5'>
          <div className='fs-5 text-gray-900 fw-bolder'>Filter Options</div>
        </div>
        {/* end::Header */}

        {/* begin::Separator */}
        <div className='separator border-gray-200'></div>
        {/* end::Separator */}

        <form onSubmit={formik.handleSubmit}>
          {/* begin::Content */}
          <div className='px-7 py-5' data-kt-user-table-filter='form'>
            <div className='mb-4'>
              <label className='form-label fs-6 fw-bold'>Show Entries:</label>
              <select
                className='form-select custom-input fw-bolder'
                data-kt-select2='true'
                data-placeholder='Select entries'
                data-hide-search='true'
                name='entries'
                id='entries'
                value={itemsPerPage}
                onChange={(e) => {
                  setCurrentPage(1)
                  setItemsPerPage(parseInt(e.target.value))
                }}
              >
                <option value='10'>10</option>
                <option value='50'>50</option>
                <option value='100'>100</option>
                <option value='250'>250</option>
              </select>
            </div>

            <div className='mb-4'>
              <label className='form-label fs-6 fw-bold'>
                <span className=''>Start Date:</span>
              </label>

              <div id='sDate' className=''>
                <PrimaryFlatPickr
                  placeholder='Select start date'
                  fieldName='sDate'
                  formik={formik}
                  container='sDate'
                />
              </div>
            </div>

            <div className='mb-4'>
              <label className='form-label fs-6 fw-bold'>
                <span className=''>End Date:</span>
              </label>

              <div id='eDate' className=''>
                <PrimaryFlatPickr
                  placeholder='Select end date'
                  fieldName='eDate'
                  formik={formik}
                  container='eDate'
                />
              </div>
            </div>

            <div className='mb-4'>
              <label className='form-label fs-6 fw-bold'>
                <span className=''>Payment type:</span>
              </label>

              <ReactSelectBox
                placeholder='Select payment type'
                formik={formik}
                fieldValue='paymentType'
                options={initPaymentMediaOptions}
              />
            </div>

            <div className='mb-4'>
              <label className='form-label fs-6 fw-bold'>
                <span className=''>Username:</span>
              </label>

              <ReactSelectBox
                placeholder='Select user'
                formik={formik}
                fieldValue='username'
                options={userInfo}
                setSelect={onSelectUser}
              />
            </div>

            <div className='mb-4'>
              <label className='form-label fs-6 fw-bold'>
                <span className=''>Status:</span>
              </label>

              <ReactSelectBox
                placeholder='Select status'
                formik={formik}
                fieldValue='status'
                options={initPaymentStatus}
              />
            </div>

            {/* begin::Actions */}
            <div className='d-flex justify-content-end'>
              <button
                type='button'
                disabled={isLoading}
                className='btn btn-light btn-active-light-primary fw-bold me-2 px-6'
                data-kt-menu-dismiss='true'
                data-kt-user-table-filter='reset'
                onClick={resetFilter}
              >
                Reset
              </button>
              <button
                disabled={isLoading}
                type='submit'
                className='btn btn-primary fw-bold px-6'
                data-kt-menu-dismiss='true'
                data-kt-user-table-filter='filter'
              >
                Apply
              </button>
            </div>
            {/* end::Actions */}
          </div>
          {/* end::Content */}
        </form>
      </div>
      {/* end::SubMenu */}
    </>
  )
}

export default PaymentListFilter
